import { color, typeStyle, units, snap } from '@m/alchemy-theme';
import { DisplayBox } from '@m/alchemy-ui/DisplayBox';
import { IconButton } from '@m/alchemy-ui/IconButton';
import styled, { css } from 'styled-components';

export const globalCss = css`
  html {
    font-size: 14px;
  }

  body {
    font-size: 14px;
    line-height: 1.4285em;
  }
`;

export const OpenButton = styled(IconButton)`
  padding: ${units(1.5)};
  &:hover {
    color: ${color('base', { palette: 'expressiveWarning' })} !important;
  }
`;

export const Popup = styled(DisplayBox)`
  position: absolute;
  width: ${snap(300)};
  right: 50px;
  top: 60px;
  padding: ${units(2)};
  z-index: 10;
  text-transform: none;
  text-align: left;
`;

export const Header = styled.div`
  ${typeStyle('subHeaderS')};
`;

export const Date = styled.div`
  ${typeStyle('labelM')};
  color: ${color('typeMeta')};
`;

export const LinkText = styled.div`
  ${typeStyle('actionS')};
  display: flex;
  align-items: center;
  color: ${color('typeLink')};
`;

export const NotificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(1.5)};
`;

export const Divider = styled.div`
  margin: ${units(1.5)} 0;
  border-bottom: 1px solid ${color('line')};
`;
